'use client';

// taken from https://reactbits.dev/text-animations/count-up
import { c as _c } from "react/compiler-runtime";
import { useInView, useMotionValue, useSpring } from 'motion/react';
import { useCallback, useEffect, useRef } from 'react';
interface CountUpProps {
  to: number;
  from?: number;
  direction?: 'up' | 'down';
  delay?: number;
  duration?: number;
  className?: string;
  startWhen?: boolean;
  separator?: string;
  onStart?: () => void;
  onEnd?: () => void;
}
function CountUp(t0) {
  const $ = _c(33);
  const {
    to,
    from: t1,
    direction: t2,
    delay: t3,
    duration: t4,
    className: t5,
    startWhen: t6,
    separator: t7,
    onStart,
    onEnd
  } = t0;
  const from = t1 === undefined ? 0 : t1;
  const direction = t2 === undefined ? "up" : t2;
  const delay = t3 === undefined ? 0 : t3;
  const duration = t4 === undefined ? 1 : t4;
  const className = t5 === undefined ? "" : t5;
  const startWhen = t6 === undefined ? true : t6;
  const separator = t7 === undefined ? "" : t7;
  const ref = useRef(null);
  const motionValue = useMotionValue(direction === "down" ? to : from);
  let t8;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      damping: 80,
      stiffness: 900
    };
    $[0] = t8;
  } else {
    t8 = $[0];
  }
  const springValue = useSpring(motionValue, t8);
  let t9;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      once: true,
      margin: "0px"
    };
    $[1] = t9;
  } else {
    t9 = $[1];
  }
  const isInView = useInView(ref, t9);
  const getDecimalPlaces = _temp;
  let t10;
  if ($[2] !== from) {
    t10 = getDecimalPlaces(from);
    $[2] = from;
    $[3] = t10;
  } else {
    t10 = $[3];
  }
  let t11;
  if ($[4] !== to) {
    t11 = getDecimalPlaces(to);
    $[4] = to;
    $[5] = t11;
  } else {
    t11 = $[5];
  }
  const maxDecimals = Math.max(t10, t11);
  let t12;
  if ($[6] !== maxDecimals || $[7] !== separator) {
    t12 = latest => {
      const hasDecimals = maxDecimals > 0;
      const options = {
        useGrouping: !!separator,
        minimumFractionDigits: hasDecimals ? maxDecimals : 0,
        maximumFractionDigits: hasDecimals ? maxDecimals : 0
      };
      const formattedNumber = Intl.NumberFormat("en-US", options).format(latest);
      return separator ? formattedNumber.replace(/,/g, separator) : formattedNumber;
    };
    $[6] = maxDecimals;
    $[7] = separator;
    $[8] = t12;
  } else {
    t12 = $[8];
  }
  const formatValue = t12;
  let t13;
  let t14;
  if ($[9] !== direction || $[10] !== formatValue || $[11] !== from || $[12] !== to) {
    t13 = () => {
      if (ref.current) {
        ref.current.textContent = formatValue(direction === "down" ? to : from);
      }
    };
    t14 = [from, to, direction, formatValue];
    $[9] = direction;
    $[10] = formatValue;
    $[11] = from;
    $[12] = to;
    $[13] = t13;
    $[14] = t14;
  } else {
    t13 = $[13];
    t14 = $[14];
  }
  useEffect(t13, t14);
  let t15;
  let t16;
  if ($[15] !== delay || $[16] !== direction || $[17] !== duration || $[18] !== from || $[19] !== isInView || $[20] !== motionValue || $[21] !== onEnd || $[22] !== onStart || $[23] !== startWhen || $[24] !== to) {
    t15 = () => {
      if (isInView && startWhen) {
        if (typeof onStart === "function") {
          onStart();
        }
        const timeoutId = setTimeout(() => {
          motionValue.set(direction === "down" ? from : to);
        }, delay * 1000);
        const durationTimeoutId = setTimeout(() => {
          if (typeof onEnd === "function") {
            onEnd();
          }
        }, delay * 1000 + duration * 1000);
        return () => {
          clearTimeout(timeoutId);
          clearTimeout(durationTimeoutId);
        };
      }
    };
    t16 = [isInView, startWhen, motionValue, direction, from, to, delay, onStart, onEnd, duration];
    $[15] = delay;
    $[16] = direction;
    $[17] = duration;
    $[18] = from;
    $[19] = isInView;
    $[20] = motionValue;
    $[21] = onEnd;
    $[22] = onStart;
    $[23] = startWhen;
    $[24] = to;
    $[25] = t15;
    $[26] = t16;
  } else {
    t15 = $[25];
    t16 = $[26];
  }
  useEffect(t15, t16);
  let t17;
  let t18;
  if ($[27] !== formatValue || $[28] !== springValue) {
    t17 = () => {
      const unsubscribe = springValue.on("change", latest_0 => {
        if (ref.current) {
          ref.current.textContent = formatValue(latest_0);
        }
      });
      return () => {
        unsubscribe();
      };
    };
    t18 = [springValue, formatValue];
    $[27] = formatValue;
    $[28] = springValue;
    $[29] = t17;
    $[30] = t18;
  } else {
    t17 = $[29];
    t18 = $[30];
  }
  useEffect(t17, t18);
  let t19;
  if ($[31] !== className) {
    t19 = <span className={className} ref={ref} />;
    $[31] = className;
    $[32] = t19;
  } else {
    t19 = $[32];
  }
  return t19;
}
function _temp(num) {
  const str = num.toString();
  if (str.includes(".")) {
    const decimals = str.split(".")[1];
    if (parseInt(decimals) !== 0) {
      return decimals.length;
    }
  }
  return 0;
}
export { CountUp };